import { useIntl } from '@alltrails/shared/react-intl';;
import * as styles from './GiftCard1.module.scss';
import giftCardPng from './giftcard.png';
import giftCardAvif from './giftcard.avif';
import giftCardWebp from './giftcard.webp';

function GiftCard1() {
  const intl = useIntl();

  return (
    <div className={styles.gc}>
      <picture>
        <source srcSet={giftCardAvif} type="image/avif" />
        <source srcSet={giftCardWebp} type="image/webp" />
        <img alt={intl.formatMessage({ defaultMessage: 'AllTrails gift subscription' })} src={giftCardPng} />
      </picture>
    </div>
  );
}

export default GiftCard1;
